import React from "react";
import ProductsListHeader from "@ui/components/ProductsList/ProductListHeader";

export default function DealsListHeader(props) {
  return <ProductsListHeader {...props} />;
}
